import { render, staticRenderFns } from "./mainConfig.vue?vue&type=template&id=47675954&scoped=true&"
import script from "./mainConfig.vue?vue&type=script&lang=js&"
export * from "./mainConfig.vue?vue&type=script&lang=js&"
import style0 from "./mainConfig.vue?vue&type=style&index=0&id=47675954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47675954",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47675954')) {
      api.createRecord('47675954', component.options)
    } else {
      api.reload('47675954', component.options)
    }
    module.hot.accept("./mainConfig.vue?vue&type=template&id=47675954&scoped=true&", function () {
      api.rerender('47675954', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/supplier/mainConfig.vue"
export default component.exports